import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { WORKSPACE } from "constants/AuthConstant";
import StoreService from "services/storeService";
import Utils from "utils";
import openNotification from "utils/notification";
import cloneDeep from "lodash/cloneDeep";
import { WORKSPACES } from "constanst";

const getStoreList = (response) => {
  const responseData = response?.data || [];
  const locBPM = responseData.filter((item) => item.isPurchasing === false);
  return locBPM;
};

export const getStoreApi = createAsyncThunk(
  "store/getStoreApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await StoreService.storeSearchGrid(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getWorkableStoresApi = createAsyncThunk(
  "store/getWorkableStoresApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await StoreService.getWorkableStores(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getWorkableStoresByRegionApi = createAsyncThunk(
  "store/getWorkableStoresByRegionApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await StoreService.getWorkableStoresByRegion(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getMyStoreApi = createAsyncThunk(
  "store/getMyStoreApi",
  async (data, { rejectWithValue }) => {
    try {
      const isCompanyWorkspace =
        localStorage.getItem(WORKSPACE) === WORKSPACES.COMPANY;
      const response = isCompanyWorkspace
        ? await StoreService.getStoreListPartnerV2(data || {})
        : await StoreService.getMyStore(data);

      return isCompanyWorkspace ? getStoreList(response) : response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getStoreById = createAsyncThunk(
  "store/getStoreById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await StoreService.getStoreById(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const saveStore =
  (request) =>
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await request(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  };

export const createStoreApi = createAsyncThunk(
  "store/createStoreApi",
  saveStore(StoreService.createStore),
);
export const updateStoreApi = createAsyncThunk(
  "store/updateStoreApi",
  saveStore(StoreService.updateStore),
);
export const createStoreV2Api = createAsyncThunk(
  "store/createStoreV2Api",
  saveStore(StoreService.createStoreV2),
);
export const updateStoreV2Api = createAsyncThunk(
  "store/updateStoreV2Api",
  saveStore(StoreService.updateStoreV2),
);

export const updateStoreState = createAsyncThunk(
  "store/updateStoreState",
  async (data, { rejectWithValue }) => {
    try {
      const response = await StoreService.updateStoreState(data);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const delStoreApi = createAsyncThunk(
  "store/delStoreApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id, password } = data;
      const response = await StoreService.delStore({ id, password });
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getStoreUnit = createAsyncThunk(
  "store/getStoreUnit",
  async (id, { rejectWithValue }) => {
    try {
      const response = await StoreService.getStoreUnit(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const upSetStoreUnit = createAsyncThunk(
  "store/upSetStoreUnit",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await StoreService.upSetStoreUnit(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getPartnerStoreListApi = createAsyncThunk(
  "store/getPartnerStoreListApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await StoreService.getPartnerStoreList(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getPartnerStoreListV2Api = createAsyncThunk(
  "store/getPartnerStoreListV2Api",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await StoreService.getStoreListPartnerV2(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const exportStoreExcel = createAsyncThunk(
  "store/exportStoreExcel",
  async (params, { rejectWithValue }) => {
    try {
      const blob = await StoreService.exportExcel(params);
      const url = window.URL.createObjectURL(blob);
      const filename = `Danh sách chi nhánh.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  loadingExport: false,
  storeList: [],
  storeDetail: {},
  storeUnit: [],
  myStoreList: [],
  workableStores: [],
  workableStoresByRegion: [],
  partnerStoreList: [],
  partnerStoreListV2: [],
};

export const storeSlice = createSlice({
  name: "storeSlice",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setStoreDetail: (state) => {
      state.storeDetail = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStoreApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStoreApi.fulfilled, (state, action) => {
        state.loading = false;
        state.storeList = action.payload;
      })
      .addCase(getStoreApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getMyStoreApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMyStoreApi.fulfilled, (state, action) => {
        state.loading = false;
        state.myStoreList = action.payload;
      })
      .addCase(getMyStoreApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getWorkableStoresApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWorkableStoresApi.fulfilled, (state, action) => {
        state.loading = false;
        state.workableStores = action.payload;
      })
      .addCase(getWorkableStoresApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getWorkableStoresByRegionApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWorkableStoresByRegionApi.fulfilled, (state, action) => {
        state.loading = false;
        state.workableStoresByRegion = action.payload || [];
      })
      .addCase(getWorkableStoresByRegionApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getStoreById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getStoreById.fulfilled, (state, action) => {
        state.loading = false;
        state.storeDetail = action.payload;
      })
      .addCase(getStoreById.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createStoreApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(createStoreApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createStoreApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateStoreApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateStoreApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateStoreApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createStoreV2Api.pending, (state) => {
        state.loading = true;
      })
      .addCase(createStoreV2Api.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(createStoreV2Api.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateStoreV2Api.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateStoreV2Api.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateStoreV2Api.rejected, (state) => {
        state.loading = false;
      })
      .addCase(delStoreApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(delStoreApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(delStoreApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateStoreState.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateStoreState.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateStoreState.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getStoreUnit.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getStoreUnit.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;

        state.loading = false;
        state.storeUnit = action.payload;
      })
      .addCase(getStoreUnit.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;

        state.loading = false;
      })
      .addCase(upSetStoreUnit.pending, (state) => {
        state.loading = true;
      })
      .addCase(upSetStoreUnit.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(upSetStoreUnit.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getPartnerStoreListApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPartnerStoreListApi.fulfilled, (state, action) => {
        state.loading = false;
        state.partnerStoreList = action.payload;
      })
      .addCase(getPartnerStoreListApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(getPartnerStoreListV2Api.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPartnerStoreListV2Api.fulfilled, (state, action) => {
        state.loading = false;
        state.partnerStoreListV2 = action.payload;
      })
      .addCase(getPartnerStoreListV2Api.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(exportStoreExcel.pending, (state) => {
        state.loadingExport = true;
      })
      .addCase(exportStoreExcel.fulfilled, (state) => {
        state.loadingExport = false;
      })
      .addCase(exportStoreExcel.rejected, (state) => {
        state.loadingExport = false;
      });
  },
});

export const { showLoading, setStoreDetail } = storeSlice.actions;

export default storeSlice.reducer;
